import { render, staticRenderFns } from "./GlobalImportDialog.vue?vue&type=template&id=8057fb12&scoped=true&"
import script from "./GlobalImportDialog.vue?vue&type=script&lang=js&"
export * from "./GlobalImportDialog.vue?vue&type=script&lang=js&"
import style0 from "./GlobalImportDialog.vue?vue&type=style&index=0&id=8057fb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8057fb12",
  null
  
)

export default component.exports